var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtility10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_3668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.291 33.4361L30.0483 38.7163L38.1637 31.2736C38.4478 31.0131 38.6731 30.7039 38.8269 30.3636C38.9807 30.0232 39.0598 29.6585 39.0598 29.29V11.7097C39.0598 11.3412 38.9807 10.9765 38.8269 10.6361C38.6731 10.2958 38.4478 9.98659 38.1637 9.72614L30.0534 2.28809L24.296 7.56818L36.2337 18.5164C36.518 18.7771 36.7434 19.0865 36.8971 19.4272C37.0508 19.7678 37.1298 20.1328 37.1296 20.5015C37.1294 20.8701 37.05 21.235 36.8957 21.5756C36.7416 21.916 36.5158 22.2253 36.2313 22.4856L24.291 33.4361Z",
    fill: "#37ABFF",
    stroke: "#37ABFF",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83594 33.4361L8.59329 38.7163L16.7087 31.2736C16.9927 31.0131 17.2181 30.7039 17.3719 30.3636C17.5256 30.0232 17.6048 29.6585 17.6048 29.29V11.7097C17.6048 11.3412 17.5256 10.9765 17.3719 10.6361C17.2181 10.2958 16.9927 9.98659 16.7087 9.72614L8.59829 2.28809L2.84094 7.56818L14.7787 18.5164C15.0629 18.7771 15.2883 19.0865 15.4421 19.4272C15.5957 19.7678 15.6748 20.1328 15.6746 20.5015C15.6743 20.8701 15.5948 21.235 15.4407 21.5756C15.2866 21.916 15.0608 22.2253 14.7762 22.4856L2.83594 33.4361Z",
    fill: "#37ABFF",
    stroke: "#37ABFF",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_3668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility10);
export default __webpack_public_path__ + "static/media/utility10.5331ce2b808c7d0b15f2b3398b0d6445.svg";
export { ForwardRef as ReactComponent };